<script setup lang="ts">
import { ref } from 'vue';

import BaseButton from '../BaseButton/BaseButton.vue';

const isConfirmedInLocalStorage = ref(localStorage.getItem('cookieConsentConfirmed') === 'true');

const onConfirmed = (): void => {
  localStorage.setItem('cookieConsentConfirmed', 'true');

  isConfirmedInLocalStorage.value = true;
};
</script>
<template>
  <div
    v-if="!isConfirmedInLocalStorage"
    class="fixed bottom-0 left-0 right-0 z-50 p-8 m-8 bg-secondaryOffWhite text-white border-[1px] border-solid rounded-xl border-primaryGold"
  >
    <div class="flex flex-col items-center justify-center gap-4">
      <span class="pl-8 py-2 text-primaryGold bg-secondaryOffWhite text-4xl">
        Ta strona korzysta z plików cookie, aby zapewnić najlepszą jakość korzystania z naszej strony.
      </span>
      <div class="flex flex-row items-center justify-center gap-4">
        <BaseButton
          :disabled="false"
          :loading="false"
          button-text="Zgadzam się"
          :class="['bg-primaryGold', 'text-secondaryOffWhite']"
          :text-class="['text-3xl']"
          :icon="'pi-check'"
          @clicked="onConfirmed"
        />
      </div>
    </div>
  </div>
</template>
